var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertStationLocator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 47,
    viewBox: "0 0 76 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 38.5,
    rx: 38,
    ry: 8.5,
    fill: "#F04438",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0C30.4186 0 24.25 5.89961 24.25 13.1484C24.25 16.6005 25.8235 21.1913 28.9267 26.7936C31.4189 31.2916 34.3021 35.359 35.8017 37.3828C36.0551 37.7286 36.3864 38.0098 36.7688 38.2037C37.1512 38.3975 37.5739 38.4986 38.0026 38.4986C38.4313 38.4986 38.854 38.3975 39.2363 38.2037C39.6187 38.0098 39.95 37.7286 40.2034 37.3828C41.7005 35.359 44.5863 31.2916 47.0784 26.7936C50.1765 21.193 51.75 16.6023 51.75 13.1484C51.75 5.89961 45.5814 0 38 0Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0C30.4186 0 24.25 5.89961 24.25 13.1484C24.25 16.6005 25.8235 21.1913 28.9267 26.7936C31.4189 31.2916 34.3021 35.359 35.8017 37.3828C36.0551 37.7286 36.3864 38.0098 36.7688 38.2037C37.1512 38.3975 37.5739 38.4986 38.0026 38.4986C38.4313 38.4986 38.854 38.3975 39.2363 38.2037C39.6187 38.0098 39.95 37.7286 40.2034 37.3828C41.7005 35.359 44.5863 31.2916 47.0784 26.7936C50.1765 21.193 51.75 16.6023 51.75 13.1484C51.75 5.89961 45.5814 0 38 0Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2551 16.2794H44.9444C45.3221 16.2784 45.6668 16.4699 45.8276 16.7723C45.9884 17.0747 45.9367 17.4315 45.6944 17.6881L35.3279 28.738C35.1341 28.9286 34.8213 28.984 34.5603 28.8732C34.2993 28.7623 34.1517 28.5125 34.2002 28.2597L36.3058 18.8149H31.0504C30.7553 18.8129 30.4766 18.6933 30.2927 18.4892C30.1088 18.286 30.0394 18.0196 30.1033 17.7649L32.9226 6.72168C33.0184 6.33086 33.4083 6.05183 33.8609 6.04989H41.2198C41.5259 6.046 41.8145 6.17336 41.9951 6.39114C42.1823 6.6021 42.2428 6.88014 42.1591 7.13778L39.2551 16.2794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertStationLocator);
export default __webpack_public_path__ + "static/media/alert-station-locator.3401e284c4887e53801ab6a21f383129.svg";
export { ForwardRef as ReactComponent };